export enum GeoHeaders {
  Latitude = 'geoip-latitude',
  Longitude = 'geoip-longitude',
}
